import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { PublisherResource, publishersPut } from '~/generated';
import { extractData } from '~/utils/query-utils';
import { PublisherParam } from '~/generated';

type Publisher = Omit<PublisherResource, 'id' | 'partner' | 'congregation'> & {
  partner?: number | null;
  congregation: number | null;
};

export const useEditPublisher = (
  id: number,
  options: UseMutationOptions<void, unknown, Publisher, unknown> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (publisher: Publisher) =>
      extractData(
        publishersPut({
          path: { id },
          body: publisher as unknown as PublisherParam,
        })
      ),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['publisher', id],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
